import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getEmployeeDetails = async ({
  companyCode,
  employeeCode,
  locationCode,
}) => {
  if (!companyCode || !employeeCode || !locationCode) {
    throw new Error(
      "Company code, Location code and employee code are required"
    );
  }
  try {
    const { data } = await http_payroll.get(
      `${Api_EndPoints.GetEmployeeDetails}?CompanyCode=${companyCode}&EmployeeCode=${employeeCode}`
    );
    return data;
  } catch (error) {
    console.error("Error fetching employee details", error);
    throw error;
  }
};

export const useGetEmployeeDetailsQuery = ({
  companyCode,
  employeeCode,
  locationCode,
}) => {
  if (!companyCode || !employeeCode || !locationCode) {
    throw new Error(
      "Company code, Location code and employee code are required"
    );
  }

  return useQuery({
    queryKey: [Api_EndPoints.GetEmployeeDetails],
    queryFn: () =>
      getEmployeeDetails({ companyCode, employeeCode, locationCode }),
    refetchOnWindowFocus: false,
  });
};

const getEmployeeId = async ({ companyCode }) => {
  if (!companyCode) {
    throw new Error("Company code is required");
  }
  try {
    const { data } = await http_payroll.get(
      `${Api_EndPoints.GetEmployeeId}?CompanyCode=${companyCode}`
    );
    return data;
  } catch (error) {
    console.error("Error fetching employee details", error);
    throw error;
  }
};
export const useGetEmployeeIdQuery = ({ companyCode }) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetEmployeeId],
    queryFn: () => getEmployeeId({ companyCode }),
    refetchOnWindowFocus: true,
  });
};

const getEmployeeHikeDetails = async ({ companyCode, employeeCode }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetEmployeeSalaryHike}?CompanyCode=${companyCode}&EmployeeCode=${employeeCode}`
  );
  return data;
};

export const useGetEmployeeHikeDetailsQuery = ({
  companyCode,
  employeeCode,
  locationCode,
}) => {

  
  const canFetch = !!companyCode && !!employeeCode;

  const queryResult1 = useQuery({
    queryKey: [Api_EndPoints.GetEmployeeSalaryHike, companyCode, employeeCode],
    queryFn: () => getEmployeeHikeDetails({ companyCode, employeeCode }),
    // enabled: canFetch,
    refetchOnWindowFocus: false,
  });

  const queryResult2 = useQuery({
    queryKey: [Api_EndPoints.GetEmployeeDetails, companyCode, employeeCode],
    queryFn: () => getEmployeeDetails({ companyCode, employeeCode, locationCode }),
    // enabled: canFetch,
    refetchOnWindowFocus: false,
  });

  return {
    salaryHikeDetails: queryResult1.data,
    employeeInfo: queryResult2.data,
    isLoading: queryResult1.isLoading || queryResult2.isLoading,
    isError: queryResult1.isError || queryResult2.isError,
    error: queryResult1.error || queryResult2.error,
    refetch: queryResult1.refetch,
  };
};

const getEmpWorkingHourDetails = async ({
  companyCode,
  locationCode,
  employeeCode,
  departmentCode,
}) => {
  if (!companyCode || !locationCode) {
    throw new Error("Company code and employee code are required");
  }
  let queryString = `?CompanyCode=${companyCode}&LocationCode=${locationCode}`;

  if (employeeCode) {
    queryString += `&EmployeeCode=${employeeCode}`;
  }

  if (departmentCode) {
    queryString += `&DepartmentCode=${departmentCode}`;
  }
  try {
    const { data } = await http_payroll.get(
      `${Api_EndPoints.GetEmployeesWorkingHours}${queryString}`
    );
    return data;
  } catch (error) {
    console.error("Error fetching employee details", error);
    throw error;
  }
};

export const useGetEmpWorkingHourDetailsQuery = (input) => {
  
  return useQuery({
    queryKey: [Api_EndPoints.getEmpWorkingHourDetails],
    queryFn: () => getEmpWorkingHourDetails(input),
    refetchOnWindowFocus: false,
  });
};
